module.exports = __webpack_public_path__ + "4351ec0b14cbcf57e70c85d72dd034e4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/witch-hat.png
// module id = 2347
// module chunks = 0